"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.graphqlRequest = void 0;
const graphql_request_1 = require("graphql-request");
let client;
const configureGraphQlClient = ({ endPoint, headers, }) => {
    client = new graphql_request_1.GraphQLClient(endPoint);
    if (headers) {
        client.setHeaders(headers);
    }
};
async function graphqlRequest(query) {
    return client.request(query);
}
exports.graphqlRequest = graphqlRequest;
exports.default = configureGraphQlClient;
